import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { contactInfo } from '../data';

// Omfattende samling af autentiske billeder fra Munkgaard Træbyg med billedtekster og links til ydelser
const galleryItems = [
  // 1. Sommerhus & Nybyggeri i træ
  {
    id: "nybyg-1",
    title: "Moderne arkitekttegnet sommerhus i træ",
    category: "Sommerhus",
    filterGroup: "Sommerhus & Nybyggeri",
    serviceTitle: "Nybyggeri af sommerhus",
    serviceLink: "/vi-tilbyder/nybyggeri-i-trae/sommerhus",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260716-170800.jpg",
    caption: "Nybygget sommerhus med store glaspartier og integreret terrasse i naturlige træmaterialer."
  },
  {
    id: "nybyg-2",
    title: "Sommerhus i træ med stor sammenhængende terrasse",
    category: "Sommerhus",
    filterGroup: "Sommerhus & Nybyggeri",
    serviceTitle: "Sommerhus i træ",
    serviceLink: "/vi-tilbyder/nybyggeri-i-trae/sommerhus",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260707-214047.jpg",
    caption: "Klassisk og tidløst træbyggeri tilpasset grundens natur og orientering mod solen."
  },
  {
    id: "nybyg-3",
    title: "Moderne træbyggeri med rene nordiske linjer",
    category: "Nybyggeri i træ",
    filterGroup: "Sommerhus & Nybyggeri",
    serviceTitle: "Helårshus & træbyggeri",
    serviceLink: "/vi-tilbyder/nybyggeri-i-trae/helaarshus",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260309-152705.jpg",
    caption: "Bæredygtig og energieffektiv trækonstruktion med sundt indeklima og smuk arkitektur."
  },
  {
    id: "nybyg-4",
    title: "Helårshus i træ med gennemtænkte detaljer",
    category: "Helårshus",
    filterGroup: "Sommerhus & Nybyggeri",
    serviceTitle: "Nybyggeri af helårshus",
    serviceLink: "/vi-tilbyder/nybyggeri-i-trae/helaarshus",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/img-6188_eff36820.jpg",
    caption: "Komplet opførelse af træhus med fokus på holdbarhed, æstetik og præcisionshåndværk."
  },
  {
    id: "nybyg-5",
    title: "Facadearbejde og trækonstruktion på sommerhus",
    category: "Sommerhus",
    filterGroup: "Sommerhus & Nybyggeri",
    serviceTitle: "Sommerhus i træ",
    serviceLink: "/vi-tilbyder/nybyggeri-i-trae/sommerhus",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260303-093036_df44c8cb.jpg",
    caption: "Detaljearbejde og præcise samlinger på udvendige træfacader."
  },

  // 2. Terrasser & Uderum
  {
    id: "terrasse-1",
    title: "Stor hævet træterrasse i lærketræ med trapper",
    category: "Terrasser & Uderum",
    filterGroup: "Terrasser & Uderum",
    serviceTitle: "Terrasser og uderum",
    serviceLink: "/vi-tilbyder/service/terrasser-og-uderum",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260707-214047_461d7779.jpg",
    caption: "Eksklusiv træterrasse med integrerede trin, der forbinder huset harmonisk med haven."
  },
  {
    id: "terrasse-2",
    title: "Specialtilpasset terrasse med præcise smig og hjørner",
    category: "Terrasser & Uderum",
    filterGroup: "Terrasser & Uderum",
    serviceTitle: "Træterrasse på mål",
    serviceLink: "/vi-tilbyder/service/terrasser-og-uderum",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260702-164306.jpg",
    caption: "Terrassebyggeri udført med højeste faglige præcision og skjult montage."
  },
  {
    id: "terrasse-3",
    title: "Nylagt træterrasse i holdbare terrassebrædder",
    category: "Terrasser & Uderum",
    filterGroup: "Terrasser & Uderum",
    serviceTitle: "Terrasser og uderum",
    serviceLink: "/vi-tilbyder/service/terrasser-og-uderum",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260625-112308.jpg",
    caption: "Skab et funktionelt og hyggeligt uderum, der kan nydes år efter år."
  },
  {
    id: "terrasse-4",
    title: "Overdækket uderum og sammenhængende træterrasse",
    category: "Terrasser & Uderum",
    filterGroup: "Terrasser & Uderum",
    serviceTitle: "Terrasser og uderum",
    serviceLink: "/vi-tilbyder/service/terrasser-og-uderum",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260618-122657.jpg",
    caption: "Optimal udnyttelse af haven med overdækket areal og lækroge."
  },
  {
    id: "terrasse-5",
    title: "Solterrasse med udsigt til naturen",
    category: "Terrasser & Uderum",
    filterGroup: "Terrasser & Uderum",
    serviceTitle: "Træterrasser",
    serviceLink: "/vi-tilbyder/service/terrasser-og-uderum",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260716-170909.jpg",
    caption: "Terrassekonstruktion tilpasset skrånende terræn og naturlige omgivelser."
  },

  // 3. Tilbygninger
  {
    id: "tilbyg-1",
    title: "Harmonisk tilbygning i træ til parcelhus",
    category: "Tilbygning",
    filterGroup: "Tilbygning",
    serviceTitle: "Tilbygning til bolig",
    serviceLink: "/vi-tilbyder/tilbygning",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260609-075822.jpg",
    caption: "Ekstra kvadratmeter til boligen opført med respekt for det oprindelige hus' arkitektur."
  },
  {
    id: "tilbyg-2",
    title: "Spær- og tagkonstruktion ved ny tilbygning",
    category: "Tilbygning",
    filterGroup: "Tilbygning",
    serviceTitle: "Tilbygning",
    serviceLink: "/vi-tilbyder/tilbygning",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260417-132325.jpg",
    caption: "Solidt tømrerarbejde og opbygning af spærfag og råhus til udvidelse af bolig."
  },
  {
    id: "tilbyg-3",
    title: "Opførelse af råhus og isolering til tilbygning",
    category: "Tilbygning",
    filterGroup: "Tilbygning",
    serviceTitle: "Tilbygning i træ",
    serviceLink: "/vi-tilbyder/tilbygning",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260417-132221.jpg",
    caption: "Korrekt isolering, dampspærre og bærende trækonstruktioner efter gældende bygningsreglement."
  },
  {
    id: "tilbyg-4",
    title: "Tilbygning med ny stue og store vinduespartier",
    category: "Tilbygning",
    filterGroup: "Tilbygning",
    serviceTitle: "Tilbygninger",
    serviceLink: "/vi-tilbyder/tilbygning",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20250925-191338_384e8a27.jpg",
    caption: "Få mere lys og plads i hverdagen med en moderne tilbygning i træ."
  },

  // 4. Udhuse, Garage & Carport, Anneks & Skur
  {
    id: "udhus-1",
    title: "Fuldisoleret garage i træ med automatisk port",
    category: "Garage & Carport",
    filterGroup: "Udhuse, Garage & Skur",
    serviceTitle: "Garage og carport",
    serviceLink: "/vi-tilbyder/udhuse/garage-og-carport",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/img20250818111542.jpg",
    caption: "Rummelig garage opført i holdbare træprofiler, der passer perfekt til ejendommen."
  },
  {
    id: "udhus-2",
    title: "Dobbelt carport med integreret isoleret værksted",
    category: "Garage & Carport",
    filterGroup: "Udhuse, Garage & Skur",
    serviceTitle: "Garage og carport",
    serviceLink: "/vi-tilbyder/udhuse/garage-og-carport",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/img20250818111533.jpg",
    caption: "Praktisk overdække til biler kombineret med aflåst opbevarings- og redskabsrum."
  },
  {
    id: "udhus-3",
    title: "Arkitekttegnet anneks til gæster og hjemmekontor",
    category: "Anneks",
    filterGroup: "Udhuse, Garage & Skur",
    serviceTitle: "Anneks i træ",
    serviceLink: "/vi-tilbyder/udhuse/anneks",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260310-142612.jpg",
    caption: "Lyst og fuldisoleret anneks med mange anvendelsesmuligheder året rundt."
  },
  {
    id: "udhus-4",
    title: "Anneks opført i smuk lodret træbeklædning",
    category: "Anneks",
    filterGroup: "Udhuse, Garage & Skur",
    serviceTitle: "Anneks",
    serviceLink: "/vi-tilbyder/udhuse/anneks",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20250925-155450.jpg",
    caption: "Ekstra sovepladser eller hobbyrum bygget med solide materialer og høj finish."
  },
  {
    id: "udhus-5",
    title: "Specialbygget redskabsskur med klinkbeklædning",
    category: "Skur",
    filterGroup: "Udhuse, Garage & Skur",
    serviceTitle: "Skure og redskabsrum",
    serviceLink: "/vi-tilbyder/udhuse/skur",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260424-081002.jpg",
    caption: "Praktisk haveskur til haveredskaber, cykler og havemøbler med god ventilation."
  },
  {
    id: "udhus-6",
    title: "Opførelse af udhus med solid tagpap-løsning",
    category: "Skur",
    filterGroup: "Udhuse, Garage & Skur",
    serviceTitle: "Skur",
    serviceLink: "/vi-tilbyder/udhuse/skur",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260424-080930.jpg",
    caption: "Tæt og holdbart tagarbejde udført på nyopført udhus."
  },
  {
    id: "udhus-7",
    title: "Udhus og carport i ensartet træstil",
    category: "Udhuse",
    filterGroup: "Udhuse, Garage & Skur",
    serviceTitle: "Udhuse",
    serviceLink: "/vi-tilbyder/udhuse",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20251111-120209.jpg",
    caption: "Helhedsorienteret løsning der giver grunden et stilrent og ryddeligt udtryk."
  },

  // 5. Totalrenovering & Ombygning
  {
    id: "reno-1",
    title: "Totalrenovering af stue og alrum",
    category: "Totalrenovering",
    filterGroup: "Totalrenovering",
    serviceTitle: "Totalrenovering",
    serviceLink: "/vi-tilbyder/totalrenovering",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20251118-085903-1.jpg",
    caption: "Komplet modernisering af boligens opholdsrum med nye vægge, lofter og isolering."
  },
  {
    id: "reno-2",
    title: "Facaderenovering og ny tagkonstruktion",
    category: "Totalrenovering",
    filterGroup: "Totalrenovering",
    serviceTitle: "Totalrenovering & ombygning",
    serviceLink: "/vi-tilbyder/totalrenovering",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/img20240827150458.jpg",
    caption: "Gennemgribende renovering der forvandler en ældre bolig til tidssvarende standard."
  },
  {
    id: "reno-3",
    title: "Indvendig forvandling af villa",
    category: "Totalrenovering",
    filterGroup: "Totalrenovering",
    serviceTitle: "Totalrenovering",
    serviceLink: "/vi-tilbyder/totalrenovering",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/img20240825100302.jpg",
    caption: "Nye rumfordelinger og åbne løsninger, der skaber lys og luft i hverdagen."
  },
  {
    id: "reno-4",
    title: "Ombygning med respekt for husets oprindelige sjæl",
    category: "Ombygning",
    filterGroup: "Totalrenovering",
    serviceTitle: "Totalrenovering",
    serviceLink: "/vi-tilbyder/totalrenovering",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/img20240825095743.jpg",
    caption: "Bevaring af boligens unikke karakter kombineret med moderne komfort og energioptimering."
  },

  // 6. Beklædning & Udhæng
  {
    id: "beklaed-1",
    title: "Lodret træbeklædning monteret med stor præcision",
    category: "Beklædning & Udhæng",
    filterGroup: "Beklædning & Udhæng",
    serviceTitle: "Beklædning og udhæng",
    serviceLink: "/vi-tilbyder/service/beklaedning-og-udhaeng",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/img20250603164027.jpg",
    caption: "Ventileret facadebeklædning i kvalitetsgran, der giver et skarpt arkitektonisk udtryk."
  },
  {
    id: "beklaed-2",
    title: "Gennemførte detaljer ved udhæng og tagfod",
    category: "Beklædning & Udhæng",
    filterGroup: "Beklædning & Udhæng",
    serviceTitle: "Udhæng og stern",
    serviceLink: "/vi-tilbyder/service/beklaedning-og-udhaeng",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/img20250603164043.jpg",
    caption: "Pæne overgange og holdbare afslutninger mod taget, der beskytter mod vind og vejr."
  },
  {
    id: "beklaed-3",
    title: "Facadetræ med skjult skruning og skarpe hjørner",
    category: "Beklædning & Udhæng",
    filterGroup: "Beklædning & Udhæng",
    serviceTitle: "Beklædning og udhæng",
    serviceLink: "/vi-tilbyder/service/beklaedning-og-udhaeng",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/img20250603164006.jpg",
    caption: "Håndværksmæssig præcision i alle detaljer og samlinger."
  },
  {
    id: "beklaed-4",
    title: "Udvendig træbeklædning på nyopført gavl",
    category: "Beklædning & Udhæng",
    filterGroup: "Beklædning & Udhæng",
    serviceTitle: "Træbeklædning",
    serviceLink: "/vi-tilbyder/service/beklaedning-og-udhaeng",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/img20241114113104.jpg",
    caption: "Langtidsholdbare materialer monteret med fokus på korrekt ventilation og fugtsikring."
  },

  // 7. Tagarbejde
  {
    id: "tag-1",
    title: "Nyt tag og tagarbejde på bolig",
    category: "Tag",
    filterGroup: "Tagarbejde",
    serviceTitle: "Tagarbejde & tagudskiftning",
    serviceLink: "/vi-tilbyder/service/tag",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/img20250821071223.jpg",
    caption: "Professionel lægning af nyt tag med korrekt undertag, lægter og ventilation."
  },
  {
    id: "tag-2",
    title: "Renovering af tagkonstruktion og kviste",
    category: "Tag",
    filterGroup: "Tagarbejde",
    serviceTitle: "Tagarbejde",
    serviceLink: "/vi-tilbyder/service/tag",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/img20250820161929.jpg",
    caption: "Udskiftning af slidte tagdele og efterisolering for bedre energieffektivitet."
  },
  {
    id: "tag-3",
    title: "Nye tagrender, sternbrædder og tagrender",
    category: "Tag",
    filterGroup: "Tagarbejde",
    serviceTitle: "Tagservice",
    serviceLink: "/vi-tilbyder/service/tag",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/img20250707183256.jpg",
    caption: "Komplet tagafslutning der holder vandet væk fra konstruktionen."
  },

  // 8. Døre & Vinduer
  {
    id: "doere-1",
    title: "Montering af store panoramavinduer og skydedøre",
    category: "Døre & Vinduer",
    filterGroup: "Døre & Vinduer",
    serviceTitle: "Døre og vinduer",
    serviceLink: "/vi-tilbyder/service/doere-vinduer",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260707-214057.jpg",
    caption: "Store lysindfald og energirigtige glaspartier monteret med præcise fuger."
  },
  {
    id: "doere-2",
    title: "Udskiftning af facadedør og vinduespartier",
    category: "Døre & Vinduer",
    filterGroup: "Døre & Vinduer",
    serviceTitle: "Døre og vinduer",
    serviceLink: "/vi-tilbyder/service/doere-vinduer",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20251114-092244.jpg",
    caption: "Energivenlige døre og vinduer, der reducerer varmeregningen og forbedrer indeklimaet."
  },
  {
    id: "doere-3",
    title: "Nye vinduer med flot udvendig inddækning",
    category: "Døre & Vinduer",
    filterGroup: "Døre & Vinduer",
    serviceTitle: "Vinduesudskiftning",
    serviceLink: "/vi-tilbyder/service/doere-vinduer",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/img20250520160204.jpg",
    caption: "Professionel montering med fokus på tæthed, lige linjer og pæne tilsætninger."
  },

  // 9. Køkken & Interiør
  {
    id: "koekken-1",
    title: "Montering af nyt moderne køkken",
    category: "Køkken & Interiør",
    filterGroup: "Køkken & Interiør",
    serviceTitle: "Køkken og interiør",
    serviceLink: "/vi-tilbyder/service/koekken-og-interioer",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/img20250709081240.jpg",
    caption: "Præcis opsætning af køkkenelementer, bordplader og hårde hvidevarer."
  },
  {
    id: "koekken-2",
    title: "Snedkerløsninger og detaljer i køkken-alrum",
    category: "Køkken & Interiør",
    filterGroup: "Køkken & Interiør",
    serviceTitle: "Køkken og snedkerløsninger",
    serviceLink: "/vi-tilbyder/service/koekken-og-interioer",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/img20250709081224.jpg",
    caption: "Indbyggede løsninger, tilpasninger og finish der fuldender køkkenet."
  },
  {
    id: "koekken-3",
    title: "Specialtilpassede indretningsløsninger i træ",
    category: "Køkken & Interiør",
    filterGroup: "Køkken & Interiør",
    serviceTitle: "Interiør og snedkerarbejde",
    serviceLink: "/vi-tilbyder/service/koekken-og-interioer",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/img20240825100315.jpg",
    caption: "Gennemtænkt udnyttelse af pladsen med skræddersyede detaljer."
  },

  // 10. Gulv, Væg & Loft
  {
    id: "gulv-1",
    title: "Lægning af nyt trægulv med præcis finish",
    category: "Gulv, Væg & Loft",
    filterGroup: "Gulv, Væg & Loft",
    serviceTitle: "Gulv, væg og loft",
    serviceLink: "/vi-tilbyder/service/gulv-vaeg-loft",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260417-132325_61049784.jpg",
    caption: "Flot gulvlægning med pæne fodpaneler og lige overgange mellem rum."
  },
  {
    id: "gulv-2",
    title: "Nye lofter med integreret belysning og akustik",
    category: "Gulv, Væg & Loft",
    filterGroup: "Gulv, Væg & Loft",
    serviceTitle: "Gulv, væg og loft",
    serviceLink: "/vi-tilbyder/service/gulv-vaeg-loft",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260126-111844.jpg",
    caption: "Gipslofter og akustiklister der forbedrer rumklang og lysforhold i boligen."
  },
  {
    id: "gulv-3",
    title: "Indvendig vægbeklædning og finish",
    category: "Gulv, Væg & Loft",
    filterGroup: "Gulv, Væg & Loft",
    serviceTitle: "Tømrerarbejde i boligen",
    serviceLink: "/vi-tilbyder/service/gulv-vaeg-loft",
    image: "https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20251125-112450.jpg",
    caption: "Opsætning af nye skillevægge og beklædninger med plan overflade."
  }
];

// Unikke filterkategorier
const filterCategories = [
  "Alle billeder",
  "Sommerhus & Nybyggeri",
  "Tilbygning",
  "Udhuse, Garage & Skur",
  "Totalrenovering",
  "Terrasser & Uderum",
  "Beklædning & Udhæng",
  "Tagarbejde",
  "Døre & Vinduer",
  "Køkken & Interiør",
  "Gulv, Væg & Loft"
];

export default function References() {
  const [activeFilter, setActiveFilter] = useState("Alle billeder");
  const [activeImageIndex, setActiveImageIndex] = useState(null);

  const filteredItems = activeFilter === "Alle billeder"
    ? galleryItems
    : galleryItems.filter(item => item.filterGroup === activeFilter);

  const openLightbox = (index) => {
    setActiveImageIndex(index);
  };

  const closeLightbox = () => {
    setActiveImageIndex(null);
  };

  const showNextImage = (e) => {
    e?.stopPropagation();
    if (activeImageIndex !== null) {
      setActiveImageIndex((prev) => (prev + 1) % filteredItems.length);
    }
  };

  const showPrevImage = (e) => {
    e?.stopPropagation();
    if (activeImageIndex !== null) {
      setActiveImageIndex((prev) => (prev - 1 + filteredItems.length) % filteredItems.length);
    }
  };

  // Keyboard navigation for lightbox
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (activeImageIndex === null) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') showNextImage();
      if (e.key === 'ArrowLeft') showPrevImage();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [activeImageIndex, filteredItems.length]);

  return (
    <div className="bg-stone-50 min-h-screen">
      <SEO />

      {/* Hero Header */}
      <section className="relative py-20 sm:py-28 bg-stone-900 text-white overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img 
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/eb528839-41b2-4674-9198-41967ffbbdbc/20260707-214047_461d7779.jpg" 
            alt="Munkgaard Træbyg Galleri" 
            className="w-full h-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-stone-900 via-stone-900/60 to-transparent" />
        </div>

        <div className="relative z-10 max-w-5xl mx-auto px-6 text-center flex flex-col gap-4">
          <span className="text-accent-light font-semibold tracking-[0.2em] uppercase text-xs">
            Munkgaard Træbyg ApS
          </span>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white">
            Galleri
          </h1>
          <p className="text-stone-300 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
            Se et udvalg af billeder fra vores arbejde med træbyggeri, sommerhuse, tilbygninger, udhuse og renoveringer. Klik på et billede for at se det i fuld størrelse eller følg linket for at læse mere om ydelsen.
          </p>
        </div>
      </section>

      {/* Filter Tabs */}
      <section className="py-8 bg-white border-b border-stone-200 sticky top-24 z-30 shadow-xs">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-none sm:flex-wrap sm:justify-center">
            {filterCategories.map((cat) => {
              const count = cat === "Alle billeder" 
                ? galleryItems.length 
                : galleryItems.filter(i => i.filterGroup === cat).length;

              return (
                <button
                  key={cat}
                  onClick={() => setActiveFilter(cat)}
                  className={`px-4 py-2 rounded-full text-xs font-semibold tracking-wider uppercase whitespace-nowrap transition-all duration-300 cursor-pointer flex items-center gap-2 shrink-0 ${
                    activeFilter === cat
                      ? 'bg-accent text-white shadow-sm'
                      : 'bg-stone-100 text-stone-700 hover:bg-stone-200 hover:text-stone-900'
                  }`}
                >
                  <span>{cat}</span>
                  <span className={`text-[10px] px-1.5 py-0.5 rounded-full ${
                    activeFilter === cat ? 'bg-white/20 text-white' : 'bg-stone-200 text-stone-600'
                  }`}>
                    {count}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-12 sm:py-16 max-w-7xl mx-auto px-6">
        <div className="mb-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-stone-200/80 pb-4">
          <div>
            <h2 className="font-display text-2xl font-bold text-stone-900">
              {activeFilter}
            </h2>
            <p className="text-stone-500 text-sm mt-1">
              Viser {filteredItems.length} billeder
            </p>
          </div>

          <div className="flex items-center gap-2 text-xs text-stone-500">
            <i className="fa-regular fa-hand-pointer text-accent" />
            <span>Klik på et billede for at forstørre</span>
          </div>
        </div>

        {filteredItems.length === 0 ? (
          <div className="text-center py-20 bg-white rounded-2xl border border-stone-200">
            <i className="fa-regular fa-images text-4xl text-stone-300 mb-3" />
            <p className="text-stone-500">Ingen billeder fundet i denne kategori.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {filteredItems.map((item, index) => {
              const resizedUrl = `https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/${item.image.replace('https://assets.auxodev.dk/', '')}`;

              return (
                <div 
                  key={item.id}
                  className="group bg-white rounded-2xl overflow-hidden border border-stone-200/80 shadow-sm hover:shadow-md transition-all duration-300 flex flex-col"
                >
                  {/* Image Container with Zoom Click */}
                  <div 
                    onClick={() => openLightbox(index)}
                    className="aspect-[4/3] relative overflow-hidden bg-stone-100 cursor-pointer"
                    role="button"
                    tabIndex={0}
                    aria-label={`Forstør billede: ${item.title}`}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openLightbox(index); }}
                  >
                    <img 
                      src={resizedUrl} 
                      alt={item.title} 
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    
                    {/* Hover Overlay */}
                    <div className="absolute inset-0 bg-stone-950/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center p-4">
                      <div className="bg-white/95 text-stone-900 px-4 py-2 rounded-full text-xs font-semibold tracking-wider uppercase shadow-md flex items-center gap-2 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                        <i className="fa-solid fa-magnifying-glass-plus text-accent" />
                        <span>Se stort billede</span>
                      </div>
                    </div>

                    {/* Category Pill Tag */}
                    <div className="absolute top-3 left-3 pointer-events-none">
                      <span className="bg-stone-900/80 backdrop-blur-md text-white text-[11px] font-semibold px-3 py-1 rounded-full uppercase tracking-wider shadow-sm">
                        {item.category}
                      </span>
                    </div>
                  </div>

                  {/* Caption & Service Link Footer */}
                  <div className="p-5 flex flex-col flex-grow justify-between gap-4">
                    <div className="flex flex-col gap-1.5">
                      <h3 className="font-display font-bold text-stone-900 text-lg group-hover:text-accent transition-colors leading-snug">
                        {item.title}
                      </h3>
                      {item.caption && (
                        <p className="text-stone-600 text-xs sm:text-sm leading-relaxed">
                          {item.caption}
                        </p>
                      )}
                    </div>

                    {/* Direct Link to "Vi tilbyder" Subpage */}
                    <div className="pt-3 border-t border-stone-100 flex items-center justify-between">
                      <Link 
                        to={item.serviceLink}
                        className="inline-flex items-center gap-2 text-xs font-bold text-accent hover:text-stone-900 uppercase tracking-wider transition-colors group/link py-1"
                      >
                        <span>Læs om {item.serviceTitle}</span>
                        <i className="fa-solid fa-arrow-right text-[10px] transition-transform duration-300 group-hover/link:translate-x-1" />
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>

      {/* Lightbox Modal */}
      {activeImageIndex !== null && filteredItems[activeImageIndex] && (
        <div 
          className="fixed inset-0 z-50 bg-stone-950/95 backdrop-blur-md flex items-center justify-center p-4 sm:p-6 select-none animate-fade-in"
          onClick={closeLightbox}
        >
          {/* Close button */}
          <button 
            onClick={closeLightbox}
            className="absolute top-4 right-4 z-20 w-12 h-12 rounded-full bg-white/10 hover:bg-white text-white hover:text-stone-900 flex items-center justify-center transition-all duration-200 cursor-pointer shadow-lg"
            aria-label="Luk galleri"
          >
            <i className="fa-solid fa-xmark text-xl" />
          </button>

          {/* Prev button */}
          <button 
            onClick={showPrevImage}
            className="absolute left-4 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-white/10 hover:bg-white text-white hover:text-stone-900 flex items-center justify-center transition-all duration-200 cursor-pointer shadow-lg"
            aria-label="Forrige billede"
          >
            <i className="fa-solid fa-chevron-left text-lg" />
          </button>

          {/* Next button */}
          <button 
            onClick={showNextImage}
            className="absolute right-4 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-white/10 hover:bg-white text-white hover:text-stone-900 flex items-center justify-center transition-all duration-200 cursor-pointer shadow-lg"
            aria-label="Næste billede"
          >
            <i className="fa-solid fa-chevron-right text-lg" />
          </button>

          {/* Modal Container */}
          <div 
            className="max-w-5xl w-full flex flex-col items-center gap-4 max-h-[92vh]"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative rounded-xl overflow-hidden shadow-2xl bg-black flex items-center justify-center max-h-[70vh] sm:max-h-[75vh]">
              <img 
                src={filteredItems[activeImageIndex].image} 
                alt={filteredItems[activeImageIndex].title} 
                className="max-w-full max-h-[70vh] sm:max-h-[75vh] object-contain rounded-lg"
              />
            </div>

            {/* Lightbox Caption Box */}
            <div className="bg-stone-900/90 backdrop-blur-md text-white p-4 sm:p-6 rounded-xl max-w-2xl w-full border border-stone-800 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
              <div className="flex flex-col gap-1">
                <span className="text-[11px] font-semibold text-accent-light uppercase tracking-wider">
                  {filteredItems[activeImageIndex].category} · Billede {activeImageIndex + 1} af {filteredItems.length}
                </span>
                <h4 className="font-display font-bold text-base sm:text-lg text-white">
                  {filteredItems[activeImageIndex].title}
                </h4>
                {filteredItems[activeImageIndex].caption && (
                  <p className="text-stone-300 text-xs sm:text-sm mt-0.5">
                    {filteredItems[activeImageIndex].caption}
                  </p>
                )}
              </div>

              <Link 
                to={filteredItems[activeImageIndex].serviceLink}
                onClick={closeLightbox}
                className="bg-accent hover:bg-accent-light text-white px-4 py-2.5 rounded-md text-xs font-semibold tracking-wider uppercase transition-colors shrink-0 flex items-center justify-center gap-2"
              >
                <span>Læs om ydelsen</span>
                <i className="fa-solid fa-arrow-right text-[10px]" />
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* Services Grid Navigation */}
      <section className="py-20 bg-white border-t border-stone-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto mb-12 flex flex-col gap-3">
            <span className="text-accent font-semibold tracking-[0.2em] uppercase text-xs">
              Hvad kan vi hjælpe med?
            </span>
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-stone-900">
              Udforsk alle vores ydelser under "Vi tilbyder"
            </h2>
            <p className="text-stone-600 text-sm sm:text-base">
              Har du et specifikt projekt i tankerne? Læs mere om hvordan vi griber opgaven an inden for vores forskellige fagområder.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <Link 
              to="/vi-tilbyder/nybyggeri-i-trae"
              className="p-6 rounded-2xl border border-stone-200 hover:border-accent/40 bg-stone-50 hover:bg-white hover:shadow-lg transition-all duration-300 group flex flex-col justify-between gap-4"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-accent/10 text-accent flex items-center justify-center shrink-0 group-hover:bg-accent group-hover:text-white transition-colors">
                  <i className="fa-solid fa-tree text-xl" />
                </div>
                <div>
                  <h3 className="font-display text-lg font-bold text-stone-900 group-hover:text-accent transition-colors">
                    Nybyggeri i træ
                  </h3>
                  <p className="text-stone-600 text-xs sm:text-sm mt-1 leading-relaxed">
                    Opførelse af moderne sommerhuse og helårshuse i træ med fokus på bæredygtighed og håndværksmæssig præcision.
                  </p>
                </div>
              </div>
              <span className="text-xs font-bold text-accent uppercase tracking-wider flex items-center gap-1">
                Læs mere <i className="fa-solid fa-chevron-right text-[10px]" />
              </span>
            </Link>

            <Link 
              to="/vi-tilbyder/tilbygning"
              className="p-6 rounded-2xl border border-stone-200 hover:border-accent/40 bg-stone-50 hover:bg-white hover:shadow-lg transition-all duration-300 group flex flex-col justify-between gap-4"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-accent/10 text-accent flex items-center justify-center shrink-0 group-hover:bg-accent group-hover:text-white transition-colors">
                  <i className="fa-solid fa-hammer text-xl" />
                </div>
                <div>
                  <h3 className="font-display text-lg font-bold text-stone-900 group-hover:text-accent transition-colors">
                    Tilbygninger
                  </h3>
                  <p className="text-stone-600 text-xs sm:text-sm mt-1 leading-relaxed">
                    Få ekstra kvadratmeter og ny opholdsstue eller værelser harmonisk tilpasset husets eksisterende stil.
                  </p>
                </div>
              </div>
              <span className="text-xs font-bold text-accent uppercase tracking-wider flex items-center gap-1">
                Læs mere <i className="fa-solid fa-chevron-right text-[10px]" />
              </span>
            </Link>

            <Link 
              to="/vi-tilbyder/udhuse"
              className="p-6 rounded-2xl border border-stone-200 hover:border-accent/40 bg-stone-50 hover:bg-white hover:shadow-lg transition-all duration-300 group flex flex-col justify-between gap-4"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-accent/10 text-accent flex items-center justify-center shrink-0 group-hover:bg-accent group-hover:text-white transition-colors">
                  <i className="fa-solid fa-warehouse text-xl" />
                </div>
                <div>
                  <h3 className="font-display text-lg font-bold text-stone-900 group-hover:text-accent transition-colors">
                    Udhuse, Garage & Anneks
                  </h3>
                  <p className="text-stone-600 text-xs sm:text-sm mt-1 leading-relaxed">
                    Garager, carporte, annekser og skure i træ – skræddersyet til dine opbevarings- og pladsbehov.
                  </p>
                </div>
              </div>
              <span className="text-xs font-bold text-accent uppercase tracking-wider flex items-center gap-1">
                Læs mere <i className="fa-solid fa-chevron-right text-[10px]" />
              </span>
            </Link>

            <Link 
              to="/vi-tilbyder/totalrenovering"
              className="p-6 rounded-2xl border border-stone-200 hover:border-accent/40 bg-stone-50 hover:bg-white hover:shadow-lg transition-all duration-300 group flex flex-col justify-between gap-4"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-accent/10 text-accent flex items-center justify-center shrink-0 group-hover:bg-accent group-hover:text-white transition-colors">
                  <i className="fa-solid fa-arrows-rotate text-xl" />
                </div>
                <div>
                  <h3 className="font-display text-lg font-bold text-stone-900 group-hover:text-accent transition-colors">
                    Totalrenovering
                  </h3>
                  <p className="text-stone-600 text-xs sm:text-sm mt-1 leading-relaxed">
                    Gennemgribende fornyelse af boligen med tryg styring og solidt tømrerhåndværk fra start til slut.
                  </p>
                </div>
              </div>
              <span className="text-xs font-bold text-accent uppercase tracking-wider flex items-center gap-1">
                Læs mere <i className="fa-solid fa-chevron-right text-[10px]" />
              </span>
            </Link>

            <Link 
              to="/vi-tilbyder/service/terrasser-og-uderum"
              className="p-6 rounded-2xl border border-stone-200 hover:border-accent/40 bg-stone-50 hover:bg-white hover:shadow-lg transition-all duration-300 group flex flex-col justify-between gap-4"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-accent/10 text-accent flex items-center justify-center shrink-0 group-hover:bg-accent group-hover:text-white transition-colors">
                  <i className="fa-solid fa-sun text-xl" />
                </div>
                <div>
                  <h3 className="font-display text-lg font-bold text-stone-900 group-hover:text-accent transition-colors">
                    Terrasser & Uderum
                  </h3>
                  <p className="text-stone-600 text-xs sm:text-sm mt-1 leading-relaxed">
                    Eksklusive træterrasser, pergolaer og uderum tilpasset haven og husets arkitektur.
                  </p>
                </div>
              </div>
              <span className="text-xs font-bold text-accent uppercase tracking-wider flex items-center gap-1">
                Læs mere <i className="fa-solid fa-chevron-right text-[10px]" />
              </span>
            </Link>

            <Link 
              to="/vi-tilbyder/service"
              className="p-6 rounded-2xl border border-stone-200 hover:border-accent/40 bg-stone-50 hover:bg-white hover:shadow-lg transition-all duration-300 group flex flex-col justify-between gap-4"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-accent/10 text-accent flex items-center justify-center shrink-0 group-hover:bg-accent group-hover:text-white transition-colors">
                  <i className="fa-solid fa-screwdriver-wrench text-xl" />
                </div>
                <div>
                  <h3 className="font-display text-lg font-bold text-stone-900 group-hover:text-accent transition-colors">
                    Serviceopgaver
                  </h3>
                  <p className="text-stone-600 text-xs sm:text-sm mt-1 leading-relaxed">
                    Tag, træbeklædning, døre/vinduer, køkkenmontering og gulv/væg/loft udført med sans for detaljen.
                  </p>
                </div>
              </div>
              <span className="text-xs font-bold text-accent uppercase tracking-wider flex items-center gap-1">
                Læs mere <i className="fa-solid fa-chevron-right text-[10px]" />
              </span>
            </Link>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-stone-900 text-white text-center border-t border-stone-800">
        <div className="max-w-3xl mx-auto px-6 flex flex-col gap-6">
          <span className="text-accent-light font-semibold tracking-[0.2em] uppercase text-xs">
            Tag en uforpligtende snak
          </span>
          <h2 className="font-display text-3xl sm:text-4xl font-bold">
            Skal vi hjælpe dig med dit næste projekt?
          </h2>
          <p className="text-stone-300 text-base sm:text-lg leading-relaxed">
            Vi står klar til at rådgive dig om materialer, design og konstruktion samt give et gennemskueligt og uforpligtende tilbud.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-2">
            <Link 
              to="/kontakt" 
              className="bg-accent hover:bg-accent-light text-white px-8 py-4 rounded-md text-base font-semibold tracking-wide transition-all duration-300 w-full sm:w-auto shadow-md"
            >
              Indhent et uforpligtende tilbud
            </Link>
            <a 
              href={`tel:${contactInfo.phoneRaw}`}
              className="bg-stone-800 hover:bg-stone-700 text-white px-8 py-4 rounded-md text-base font-semibold tracking-wide transition-all duration-300 w-full sm:w-auto border border-stone-700 flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-phone text-accent" />
              <span>Ring på {contactInfo.phone}</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
